<template>
  <div v-loading="loading" class="carousel-container">
    <el-carousel v-if="imgList?.length > 0">
      <el-carousel-item v-for="(v, idx) in imgList" :key="idx">
        <!-- <img class="w-full hidden 3xl:block" :src="v" alt=""> -->
        <div class="rounded-sm w-full h-[182px] bg-cover bg-center bg-no-repeat" :style="{ backgroundImage: `url(${v})` }" />
      </el-carousel-item>
    </el-carousel>
    <div
      v-else
      class="carousel-default" 
    />
  </div>
</template>

<script setup lang="ts">
import { queryHomePageCarousel } from '@core/main/api';
import { isNull } from '@core/tools';
import { ElMessage } from 'element-plus';
import { ref } from 'vue';

const imgList = ref<string[]>([]);
const loading = ref(false);

async function fetchData() {
  loading.value = true;
  try {
    const res = await queryHomePageCarousel();

    imgList.value = res?.map((v) => v.imageUrl)?.filter((v) => !isNull(v)) || [];
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
  loading.value = false;
}

fetchData();
</script>

<style lang="scss" scoped>
.carousel-container {
  @apply w-full h-[182px] rounded-sm;

  .el-carousel {
    @apply w-full h-full;

    .el-carousel__item {
      height: 182px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-size: 30px;
      margin: 0;
    }

    :deep(.el-carousel__indicators) {
      @apply flex gap-x-1;

      .is-active {
        .el-carousel__button {
          @apply w-[24px] h-[6px] rounded-[6px];
        }
      }

      .el-carousel__button {
        @apply w-[6px] h-[6px] rounded-[50%];
      }
    }
  }

  .carousel-default {
    @apply rounded-sm w-full h-[182px] bg-cover bg-center bg-no-repeat bg-[url(@core/main/src/modules/homepage/imgs/carousel-default.png)];
  }
}
</style>